import React from 'react'
import { useUsers } from 'src/components/async/Users'
import { Owner } from 'src/Utils/globalEnums'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardOwnerFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { data: users } = useUsers()
  const noOwnerValue = {
    value: Owner.UNASSIGNED,
    label: Owner.UNASSIGNED,
  }
  const filterValues = [
    noOwnerValue,
    ...(users?.getUsersList().map((user) => ({
      label: user.getName() || user.getEmail(),
      value: user.getEmail(),
    })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_OWNER}
      filterName={FilterName.DASHBOARD_OWNER}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
